const getters = {
  getTotalDraftsCount(state) {
    return state.totalDraftsCount
  }
}

export default getters